import { render, staticRenderFns } from "./SliderTwo.vue?vue&type=template&id=49b5b9bb&scoped=true"
import script from "./SliderTwo.vue?vue&type=script&lang=js"
export * from "./SliderTwo.vue?vue&type=script&lang=js"
import style1 from "./SliderTwo.vue?vue&type=style&index=1&id=49b5b9bb&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b5b9bb",
  null
  
)

export default component.exports